/**
 * City Map Controls Component
 *
 * Displays city selection buttons above the map
 * following the original implementation pattern
 */

import {useMapStore} from '../../../features/map/store/MapStore';
import {MapConfigurationService} from '../../../Services/map/MapConfigurationService';
import {SetMapCenterUseCase} from '../../../features/stores/useCases/SetMapCenterUseCase';
import {MapboxMapService} from '../../../Services/map/MapService';

export default function CityMapControls () {
  const {center, setCenterAndBounds} = useMapStore();
  const configService = MapConfigurationService.getInstance();
  const cities = configService.getCities();

  const handleSetCityCenter = async (cityName: string) => {
    try {
      const mapService = MapboxMapService.getInstance();
      const setMapCenterUseCase = new SetMapCenterUseCase(mapService, configService);

      const result = setMapCenterUseCase.setCityCenter(cityName);
      setCenterAndBounds(result.center.lat, result.center.lng, result.zoom);
    } catch (error) {
    }
  };

  // Split cities into two rows (8 cities per row)
  const firstRowCities = cities.slice(0, 8);
  const secondRowCities = cities.slice(8);

  return (
    <div className="bg-white rounded-lg shadow-md p-3">
      <div className="flex flex-col gap-2">
        {/* First Row */}
        <div className="flex flex-wrap gap-2">
          {firstRowCities.map(city => (
            <button
              key={city.name}
              onClick={() => handleSetCityCenter(city.name)}
              className={`flex items-center gap-1 px-3 py-1.5 rounded-md transition-colors text-sm font-medium border
                ${Math.abs(center.lat - city.lat) < 0.001 && Math.abs(center.lng - city.lng) < 0.001
              ? 'bg-brand-600 text-white border-brand-600'
              : 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-brand-50 hover:text-brand-700'}
              `}
              title={city.name}
            >
              {city.name}
            </button>
          ))}
        </div>

        {/* Second Row */}
        <div className="flex flex-wrap gap-2">
          {secondRowCities.map(city => (
            <button
              key={city.name}
              onClick={() => handleSetCityCenter(city.name)}
              className={`flex items-center gap-1 px-3 py-1.5 rounded-md transition-colors text-sm font-medium border
                ${Math.abs(center.lat - city.lat) < 0.001 && Math.abs(center.lng - city.lng) < 0.001
              ? 'bg-brand-600 text-white border-brand-600'
              : 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-brand-50 hover:text-brand-700'}
              `}
              title={city.name}
            >
              {city.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
